function encodeFilters(filters) {
    return _.mapValues(
        filters,
        (filter) => encodeURIComponent(JSON.stringify(filter))
    );
}

function decodeFilters(filters) {
    return _.mapValues(
        filters,
        (filter) => JSON.parse(decodeURIComponent(filter))
    );
}

function encodeFiltersForAPI(filters) {

    return JSON.stringify(
            _.mapValues(
            filters,
            (filter) => JSON.stringify(filter.join('.'))
        )
    );
}
function fymApiServer() {
    return FYM_INFRA_BACKEND_URL;
}
export { fymApiServer, encodeFilters, decodeFilters, encodeFiltersForAPI };



/** WEBPACK FOOTER **
 ** core/client/rawr/utils/urlManipulation.js
 **/